import { DataTypes } from '../../enums/data-types.enum';
import { Guid } from '../guid';

/**
 * Describes a single field of the JSON object being built by the Add Item task. Fields form a tree:
 * object fields nest further fields via `children` (or, when `isArray` is true, via `arrayItems` -
 * one independent set of fields per array instance). Non-object fields hold their value(s) directly.
 */
export class AddItemField {
	public id = Guid();
	public name = '';
	public dataType = DataTypes.string;
	public isArray = false;
	/**
	 * Value used when dataType is not object and isArray is false. Can be a static value or an
	 * expression value. If the value is an expression, it will be evaluated at runtime and the
	 * result will be used as the field value.
	 */
	public fieldValue = '';
	/** Values used when dataType is not object and isArray is true. Each entry can be static or an expression. */
	public arrayValues: string[] = [];
	/** Nested fields used when dataType is object and isArray is false. */
	public children: AddItemField[] = [];
	/** Array instances used when dataType is object and isArray is true - each instance owns its own set of fields. */
	public arrayItems: AddItemField[][] = [];

	constructor(init?: Partial<AddItemField>) {
		if (init) {
			Object.assign(this, init);
		}
		if (!this.children) {
			this.children = [];
		}
		if (!this.arrayItems) {
			this.arrayItems = [];
		}
		if (!this.arrayValues) {
			this.arrayValues = [];
		}
		if (init?.children) {
			this.children = init.children.map(child => new AddItemField(child));
		}
		if (init?.arrayItems) {
			this.arrayItems = init.arrayItems.map(instance =>
				instance.map(child => new AddItemField(child))
			);
		}
	}
}
